import { HookAPI } from 'antd/es/modal/useModal'
import { AxiosError } from 'axios'

import ApiErrorContent, {
  type ApiErrorProductInfo,
} from '@/components/Atoms/ApiErrorContent/ApiErrorContent'
import type { ApiErrorDetail, ApiErrorResponseData } from '@/types'

import getGeneralErrorMessage from './getGeneralErrorMessage'

export const handleApiError = (
  error: unknown,
  modal: HookAPI,
  productInfo?: ApiErrorProductInfo
) => {
  let message = getGeneralErrorMessage(error)
  let details: ApiErrorDetail[] = []
  const responseData =
    error instanceof AxiosError
      ? (error.response?.data as ApiErrorResponseData | undefined)
      : undefined
  const traceId = responseData?.traceId

  if (error instanceof AxiosError) {
    if (!error.response) {
      if (
        error.message.includes('Network Error') ||
        error.code === 'ERR_NETWORK'
      ) {
        message =
          'Ошибка доступа к внешнему сервису. Обратитесь к администратору.'
      } else if (
        error.code === 'ECONNABORTED' ||
        error.message.includes('timeout')
      ) {
        message =
          'Превышено время ожидания ответа от сервера. Попробуйте еще раз.'
      } else {
        message =
          'Не удалось установить соединение с сервером. Проверьте подключение к интернету.'
      }
    } else if (responseData) {
      if (responseData.message) {
        message = responseData.message
      } else if (responseData.detail) {
        message = responseData.title
          ? `${responseData.title}: ${responseData.detail}`
          : responseData.detail
      } else if (responseData.title) {
        message = responseData.title
      }
      if (responseData.details && Array.isArray(responseData.details)) {
        details = responseData.details
      }
    }
  }

  modal.error({
    icon: null,
    title: (
      <ApiErrorContent
        message={message}
        details={details}
        traceId={traceId}
        productInfo={productInfo}
      />
    ),
    okText: 'Понятно',
    centered: true,
    closable: false,
    width: 600,
    maskClosable: true,
    keyboard: true,
    autoFocusButton: 'ok',
  })
}
